import { ValidationProps } from 'ui/common/validation/types';
import { validateComplexValue } from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { ValidationData } from 'app/area/codetable/item/validation/validate';

export const validateChecklistHierarchy = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation } = validationData;
  const categoryValidation = validateComplexValue(CodeFieldWireKey.category, codeItem, translation);

  return {
    ...categoryValidation
  };
};
